import React, {forwardRef, useState} from "react";
import {Alert, IconButton, Typography, Box, Chip} from "@mui/material";
import {Close, ContentCopy, Check} from "@mui/icons-material";
import {closeSnackbar} from "notistack";

const SnackbarCopy = forwardRef(({id, message, ...props}, ref) => {
  const [copied, setCopied] = useState({});

  const handleClose = () => {
    closeSnackbar(id);
  };

  const handleCopy = async (text, fieldKey) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied((prev) => ({...prev, [fieldKey]: true}));
      setTimeout(() => {
        setCopied((prev) => ({...prev, [fieldKey]: false}));
      }, 2000);
    } catch (err) {
      console.error("Error al copiar:", err);
    }
  };

  return (
    <Alert
      ref={ref}
      severity="success"
      action={
        <IconButton size="small" onClick={handleClose} color="inherit">
          <Close fontSize="small" />
        </IconButton>
      }
      icon={<Check sx={{color: "#fff"}} />}
      sx={{minWidth: 350, backgroundColor: "#44a047", color: "#fff"}}
    >
      <Box>
        <Typography sx={{fontSize: "1rem", fontWeight: "bold"}}>{message}</Typography>

        {props.fields &&
          props.fields.map((field, index) => (
            <Box key={index} sx={{display: "flex", alignItems: "center", gap: 1, mt: 1, mb: 0.5}}>
              <Typography variant="subtitle1" sx={{minWidth: 80}}>
                {field.label}:
              </Typography>
              <Chip label={field.value} size="small" sx={{fontFamily: "monospace", color: "#fff"}} />
              <IconButton
                size="small"
                onClick={() => handleCopy(field.copyValue || field.value, field.label)}
                color={copied[field.label] ? "#fff" : "inherit"}
              >
                {copied[field.label] ? (
                  <Check fontSize="small" sx={{color: "#fff"}} />
                ) : (
                  <ContentCopy fontSize="small" />
                )}
              </IconButton>
            </Box>
          ))}

        {props.warning && (
          <Typography variant="caption" color="#fff" sx={{mt: 1, display: "block"}}>
            ⚠️ {props.warning}
          </Typography>
        )}
      </Box>
    </Alert>
  );
});

export default SnackbarCopy;
